export const ALL_HISTORY_HOURS = 999999999
export const EXTERNAL_ALL_HISTORY_HOURS = '999999999'
